<template>
    <div class="flex flex-1">
        <!--Sidebar-->
        <aside id="sidebar" class="pt-3 bg-side-nav w-1/2 md:w-1/6 lg:w-1/6 border-r border-side-nav hidden md:block lg:block">

            <ul class="list-reset flex flex-col">
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'NonTypicalEntry'}">Non Typical Entry</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'FacultyStaffIndex'}">Faculty/Staff Users</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'HousingUserIndex'}">Housing Users</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'PermitSalesReport'}">Permit Sales Report</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'PayrollReport'}">Payroll Report</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'UserLookup'}">User Lookup</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'HousingMove'}">Housing Move</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'PermitRates'}">Permit Rates</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'ExpirePermit'}">Expire Permit</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'ReservePermit'}">Reserve Permit</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'LostHangTag'}">Lost Hang Tag</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'NewAYPermits'}">New AY Permits</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'TicketIssued'}">Ticket Issued</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'LateTicketEntry'}">Late Ticket Entry</router-link>
                </li>
                <li class="w-full h-full py-3 px-2 border-b border-light-border">
                    <router-link :to="{ name: 'TicketViolationType'}">Ticket Violation Types</router-link>
                </li>

            </ul>
        </aside>
        <main class="bg-white-300 flex-1 p-3 overflow-hidden">
            <div class="flex flex-1 flex-col md:flex-row lg:flex-row mx-2">
                <div class="w-full mx-2 overflow-hidden">
                    <router-view></router-view>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        created() {
        }
    }
</script>
